<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div class="row clearfix">
            <div v-if="messageStatus" class="alert alert-success" role="alert">
                {{ messageStatus }}
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="">
                    <div class="header">
                        <h2>Баннера</h2>
                        <router-link tag="a" :to="'/admin/stocks/add'" class="btn btn-info waves-effect m-t-15" style="margin: 15px 0">Добавить</router-link>
                    </div>
                    <div class="body table-responsive">
                        <table class="table table-bordered table-striped js-table dataTable order-table">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Заголовок</th>
                                <th>Опции</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.name}}</td>
                                    <td>
                                        <router-link class="btn btn-primary" :to="'/admin/stocks/edit/' + item.id">Изменить</router-link>
                                        <button class="btn btn-danger" @click="removeItem(item.id, index)">Удалить</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        props: [
            'message'
        ],
        data(){
            return{
                items: {},
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true
            this.axios
                .get(this.axios.defaults.baseURL + 'admin/stocks')
                .then(response => {
                    this.items = response.data.items
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })
        },

        methods: {
            removeItem(id, index ){
                this.axios
                    .delete(this.axios.defaults.baseURL + 'admin/stocks/' + id)
                    .then(response => {
                        if (response.data.message === 'success'){
                            this.items.splice(index, 1);
                            this.messageStatus = 'Успешно удален'
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/Banner/Index.vue